import { createSlice } from "@reduxjs/toolkit";
import { userService } from '../services/users.service';
import { openSnackBar } from "./snackBarReducer";
import { setUser } from './userReducer';
import { clearAuthToken, getAuthToken, setAuthToken } from '../utils/authToken';

const initialToken = getAuthToken();

export const authSlice = createSlice({
    name: "authentication",
    initialState: {
        loggingIn: false,
        loggedIn: !!initialToken,
        userToken: initialToken,
        registering: false
    },
    reducers: {
        loginRequest: state => {
            state.loggingIn = true;
        },
        loginSuccess: (state, action) => {
            state.loggingIn = false;
            state.loggedIn = true;
            state.userToken = action.payload;
            setAuthToken(action.payload);
        },
        loginFailure: state => {
            state.loggingIn = false;
            state.loggedIn = false;
        },
        registerRequest: state => {
            state.registering = true;
        },
        registerEnd: state => {
            state.registering = false;
        },
        logout: state => {
            clearAuthToken();
            state.loggedIn = false;
            state.userToken = null;
        }
    }
});

export const { loginRequest, loginSuccess, loginFailure, registerRequest, registerEnd, logout } = authSlice.actions;

export const registerUser = (user) => async (dispatch) => {
    dispatch(registerRequest());

    try {
        await userService.registerUser(user);
        dispatch(openSnackBar({
            message: `We've sent an email to ${user.email}. Please check your email to verify and continue.`,
            status: 'success'
        }));
        dispatch(registerEnd());
    } catch (error) {
        dispatch(registerEnd());
        dispatch(openSnackBar({ message: error.message, status: 'error' }));
        throw error;
    }
};

export const logUserIn = (email, password, navigate) => async (dispatch) => {
    dispatch(loginRequest());

    try {
        const respData = await userService.login(email, password);
        const token = respData && respData.data && respData.data.token;
        const user = respData && respData.data && respData.data.user;
        if (!token || !user) {
            throw new Error('Login response was missing a token or user. Please try again.');
        }
        dispatch(loginSuccess(token));
        dispatch(setUser(user));
        const username = `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.email;
        dispatch(openSnackBar({ message: `Hello ${username}!`, status: 'info' }));
        if (typeof navigate === 'function') {
            navigate('/dashboard', { replace: true });
        }
    } catch (error) {
        dispatch(loginFailure());
        dispatch(openSnackBar({ message: error.message, status: 'error' }));
    }
};

export const selectLogingIn = (state) => state.authState.loggingIn;
export const selectLoggedIn = (state) => state.authState.loggedIn;
export const selectUserToken = (state) => state.authState.userToken;

export default authSlice.reducer;
